<script setup lang="ts">
import type { DateRange } from "reka-ui";

import Content from "./Content.vue";
import Trigger from "./Trigger.vue";

import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";

const value = defineModel<DateRange>({
    required: true,
});
const emit = defineEmits(["clear"]);
</script>

<template>
    <Popover>
        <PopoverTrigger as-child class="hidden lg:flex">
            <Trigger v-model="value" />
        </PopoverTrigger>
        <PopoverContent
            class="w-auto select-none gap-0 rounded-2xl border-none bg-base-silver p-0 shadow-custom"
            :sideOffset="12"
            :side="'bottom'"
            :avoidCollisions="false"
            :align="'end'"
        >
            <Content v-model="value" @clear="emit('clear')" />
        </PopoverContent>
    </Popover>
    <Dialog>
        <DialogTrigger as-child class="lg:hidden">
            <Trigger v-model="value" />
        </DialogTrigger>
        <DialogContent
            class="w-fit select-none gap-0 rounded-2xl border-none bg-base-silver p-0 shadow-custom"
        >
            <DialogTitle class="hidden">Date Picker</DialogTitle>
            <DialogDescription class="hidden"
                >For picking dates</DialogDescription
            >
            <Content v-model="value" @clear="emit('clear')" isDialog />
        </DialogContent>
    </Dialog>
</template>
